<div class="page-main-header container-fluid">
    <div class="main-header-right row">
        <div class="main-header-left text-center col-lg-3">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/NewLogo.png" alt="" /></a>
            </div>
        </div>
        <div class="col-lg-3"></div>
        <div class="main-header-left text-center col-lg-6">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/logo2.png" alt="" /></a>
            </div>
        </div>
        <div class="mobile-sidebar">
            <div class="flex-grow-1 text-end switch-sm">
            </div>
        </div>
        <div class="vertical-mobile-sidebar">
            <i class="fa fa-bars sidebar-bar"> </i>
        </div>
        <div class="nav-right col pull-right right-menu">
            <div class="d-lg-none mobile-toggle pull-right">
                <app-feather-icons [icon]="'more-horizontal'" (click)="openMobileNav()"></app-feather-icons>
            </div>
        </div>
    </div>
</div>

<div class="card-header h5 text-white bg-primary ">
    <div class="row">
        <div class="col-10">
            <h4 class="heading text-2xl font-bold ms-5 mt-2">Features</h4>
        </div>
        <div class="col-2">
            <button (click)="addedit()" class="btn btn-xl text-dark float-right"><i
                    class="fa fa-reply"></i>&nbsp;<b>Back</b></button>
        </div>
    </div>
</div>
<!-- <div class="container">
    <div class="overflow-hidden">
        <div id="img" *ngFor="let data of eventImage">
            <img [src]="data.url" width="300" height="200" style=" margin-top:75px; padding-right:30px"
                alt="Pineapple" />
        </div>
        <div *ngFor="let data of eventData">
            <h1 class="text-center mt-2" style="font-family: araia;">{{data.title}}</h1>
            <div>
                <p>
                    <span [innerHTML]="template"></span>
                </p>
            </div>
            <div class="row" *ngIf="isApproved">
                <div class="row col-4">
                    <div class="col-3" *ngFor="let link of shareLinks">
                        <a [href]="link?.link" target="_blank" rel="noreferrer">
                            <i class="{{ link?.icon}}" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="container">
    <div class="overflow-hidden">
        <div id="img">
            <div *ngFor="let img of eventImage">
                <img [src]="img.url" width="300" height="200" style=" margin-top:75px; padding-right:30px"
                    alt="Pineapple" />
            </div>
        </div>
        <div *ngFor="let data of eventData">
            <h1 class="text-center mt-2 ff-robo">{{data.title}}</h1>
            <div>
                <p class="ff-robo">
                    <span [innerHTML]="template" style="font-family: Roboto;"></span>
                </p>
            </div>
            <div class="row" *ngIf="isApproved">
                <div class="row col-4">
                    <div class="col-3" *ngFor="let link of shareLinks">
                        <a [href]="link?.link" target="_blank" rel="noreferrer">
                            <i class="{{ link?.icon}}" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>